/**
 *
 *
 */

/* 입점업체 - 수정요청 상태 */
export const CORRECTION_STATUS = {
  WAIT: {
    title: '대기',
    color: 'gray',
  },
  APPLY: {
    title: '신청',
    color: 'blue',
  },
  REJECT: {
    title: '반려',
    color: 'orange',
  },
  APPROVE: {
    title: '승인',
    color: 'green',
  },
};

/* 입점업체 - 입점신청여부 */
export const APPLICATION_STATUS = {
  WAIT: {
    title: '대기',
    color: 'gray',
  },
  APPLY: {
    title: '신청',
    color: 'blue',
  },
  REJECT: {
    title: '반려',
    color: 'orange',
  },
  APPROVE: {
    title: '승인',
    color: 'green',
  },
  DISABLED: {
    title: '계정비활성화',
    color: 'red',
  },
};

/* 입점업체 - 영업상태 */
export const STORE_STATUS = {
  PRE_OPEN: {
    title: '영업전',
    color: 'gray',
  },
  OPEN: {
    title: '영업중',
    color: 'green',
  },
};
